import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { baseURL } from "../../../configurations/environment";
import { RequestConfig } from "../../../helpers/RequestConfig";

export const getAllDestinationsRedux = createAsyncThunk(
    "destinations/getAllDestinations",
    async () => {
        const response = await axios.get(
            `${baseURL}/api/destinations?active=0`,
            RequestConfig(),
        );
        return response.data;
    },
);

export const getDestinationForAddingTrackers = createAsyncThunk(
    "destinations/getExistDestinations",
    async (trackerId) => {
        const response = await axios.get(
            `${baseURL}/api/destinations?active=0&tracker_id=${trackerId}`,
            RequestConfig(),
        );
        return response.data;
    },
);
